// extracted by mini-css-extract-plugin
export default {"container":"newsbox_container__rhcYX","cards_container":"newsbox_cards_container__6ThHB"};